import { SECRET_KEY } from "../constants";
const moment = require('moment-timezone');

async function encryptData(data) {
  const MMTimestamp = MyanmarTimestamp();
  const dataWithTimestamp = `${data}?${MMTimestamp}`;

  // Decode the base64-encoded secret key
  const keyBinary = atob(SECRET_KEY); // Decode base64
  const keyBuffer = new Uint8Array(keyBinary.length);
  for (let i = 0; i < keyBinary.length; i++) {
    keyBuffer[i] = keyBinary.charCodeAt(i);
  }

  // Convert the secret key to a CryptoKey object
  const key = await crypto.subtle.importKey(
    "raw",
    keyBuffer,
    "AES-CBC",
    false,
    ["encrypt"]
  );

  // Generate a random IV (Initialization Vector)
  const iv = crypto.getRandomValues(new Uint8Array(16));

  // Convert data to Uint8Array
  const encodedData = new TextEncoder().encode(dataWithTimestamp);

  // Encrypt the data
  const encryptedBuffer = await crypto.subtle.encrypt(
    {
      name: "AES-CBC",
      iv: iv,
    },
    key,
    encodedData
  );

  // Convert the encrypted data and IV to base64
  const encryptedArray = new Uint8Array(encryptedBuffer);
  const encryptedBase64 = btoa(String.fromCharCode(...encryptedArray));
  const ivBase64 = btoa(String.fromCharCode(...iv));

  return { encryptedData: encryptedBase64, iv: ivBase64 };
}

export const getHeaders = async (data) => {
  return encryptData(data).then(({ encryptedData, iv }) => {
    return {
      "Content-Type": "application/json",
      "X-Encrypted-Data": encryptedData,
      "X-IV": iv,
    };
  });
};

const MyanmarTimestamp = () => {

  // Define the timezone for Myanmar
  const myanmarTimezone = 'Asia/Yangon';

  // Get the current time in the Myanmar timezone
  const myanmarTime = moment.tz(myanmarTimezone);

  // Get the Unix timestamp in seconds
  const myanmarTimestamp = myanmarTime.unix();
  console.log(myanmarTimestamp)

  return myanmarTimestamp;
};


export async function decryptData() {
    const SECRET_KEY = "Ktd14xmglkEZIuR3yxZNU5ELrJE3lAIEtqUWAc6F0/k=";
    const ENCRYPTED_DATA_BASE64 = "jDLcfhJuH/iavBUhjcnopjwu8e1L/xlvIKR5yFcrapk=";
    const IV_BASE64 = "ZYTsoJRbVhf6STF0xqLL5g==";
  // Decode the base64-encoded secret key and IV
  const keyBinary = atob(SECRET_KEY); // Decode base64
  const keyBuffer = new Uint8Array(keyBinary.length);
  for (let i = 0; i < keyBinary.length; i++) {
    keyBuffer[i] = keyBinary.charCodeAt(i);
  }

  // Decode base64-encoded encrypted data
  const encryptedDataBinary = atob(ENCRYPTED_DATA_BASE64);
  const encryptedDataBuffer = new Uint8Array(encryptedDataBinary.length);
  for (let i = 0; i < encryptedDataBinary.length; i++) {
    encryptedDataBuffer[i] = encryptedDataBinary.charCodeAt(i);
  }

  // Decode base64-encoded IV
  const ivBinary = atob(IV_BASE64);
  const ivBuffer = new Uint8Array(ivBinary.length);
  for (let i = 0; i < ivBinary.length; i++) {
    ivBuffer[i] = ivBinary.charCodeAt(i);
  }

  // Import the key
  const key = await crypto.subtle.importKey(
    "raw",
    keyBuffer,
    "AES-CBC",
    false,
    ["decrypt"]
  );

  // Decrypt the data
  try {
    const decryptedBuffer = await crypto.subtle.decrypt(
      {
        name: "AES-CBC",
        iv: ivBuffer,
      },
      key,
      encryptedDataBuffer
    );

    // Convert the decrypted data to a string
    const decryptedData = new TextDecoder().decode(decryptedBuffer);
    return decryptedData;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
}

